import rootNode from '../config/photos.json';
import photoViewerService from './photoviewer.service';

import config from '../config/index';

class GalleriesService {
    constructor() {
        this.rootPhotosJson = rootNode;
        this.initialize();
        this.currentNode = this.rootPhotosJson;
        this.currentPathArray = [];
    }

    async initialize() {
        if (!config.isLocal) {
            this.rootPhotosJson = await this.getPhotosJson();
        }
    }

    async getPhotosJson() {
        const apiResponse = await fetch(config.photosJSONUrl);
        const photosJSON = await apiResponse.json();
        return photosJSON;
    }

    setCurrentPath(pathArray) {
        if (pathArray.length) {
            // Reset path back to root
            this.currentNode = this.rootPhotosJson;

            // Traverse to the path that was passed
            pathArray.forEach(p => {
                this.currentNode = this.currentNode.children[p];
            });

            // Track current path
            this.currentPathArray = pathArray;
        } else {
            // Reset path back to root
            this.currentNode = this.rootPhotosJson;
            // Track current path
            this.currentPathArray = pathArray;
        }
    }

    getCurrentPathArray() {
        return this.currentPathArray;
    }

    getCurrentNode() {
        return this.currentNode;
    }

    getRootNode() {
        return this.rootPhotosJson;
    }

    openPhotoViewer(selectedPhoto) {
        photoViewerService.openPhotoViewer({ currentNode: this.currentNode, selectedPhoto });
    }
}

export default new GalleriesService();
